import type { ScreenSchema } from './types';

// managesOwnSectionAudio: true — the template owns the full audio sequence:
//   1. sectionActive watcher plays intro, then queues the last-visited step.
//   2. As the user scrolls DOWN, onEnter plays each step's audio.
//   3. onEnterBack (scrolling UP) updates the ping indicator but plays no audio,
//      preventing the unwanted reverse-order audio firing from onToggle.
//   4. readyForStepAudio flag ensures in-view steps don't interrupt the intro
//      when the section first activates.
//
// Tier 1 (step.audio / step.speech) is handled in the template before
// calling playSlot, consistent with other iterated templates.
const timelineSchema: ScreenSchema = {
  template: 'timeline',
  managesOwnSectionAudio: true,
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    },
    step: {
      iterate: 'steps',
      keyPrefix: 'step',
      parts: [{ field: 'title' }, { field: 'text' }]
    }
  }
};

export default timelineSchema;
